const inputWrapperSxStyles = {
  '> div': {
    flex: 1,
    marginRight: '16px',
    width: '100%',
  },
  '> div:last-child': {
    marginRight: 0,
  },
};

export const getBusinessDetailsDoubleFieldWrapperStyles = ({
  childOrder = 'first',
  isMobile,
  maxWidth = '40%',
} = {}) => ({
  display: isMobile ? 'block' : 'flex',
  justifyContent: 'stretch',
  sx: {
    ...inputWrapperSxStyles,
    [`> div:${childOrder}-of-type`]: {
      ...(isMobile && { marginBottom: '24px' }),
      maxWidth: isMobile ? '100%' : maxWidth,
    },
  },
});
